import React, { useEffect, useState } from 'react'
import StorePageTwoForm from '../createStoreForms/StorePageTwoForm';
import { useTranslation } from 'react-i18next';
import { useSingleStoreAction } from '../../../hooks/store/store';
import { Page2FormData } from '../../../pages/owner/store/CreateStorePageTwo';
import { useForm } from 'react-hook-form';
import { useCategories, useSubCategoriesByCategory } from '../../../hooks/store/categories';
import { useSectors } from '../../../hooks/store/sector';
import { useParams } from 'react-router-dom';
import { useUpdateResource } from '../../../hooks/useUpdateResource';
import LoadingButton from '../../form/LoadingButton';
import SubmitButton from '../../form/SubmitButton';
import LoadingErrorState from '../../ui/LoadingErrorState';
import UpdateStorePublicInformationForm, { StorePublicInformation } from './UpdateStorePublicInformationForm';

function UpdateStorePublicInformation() {
        const {t} = useTranslation();
        const { storeId} = useParams<{ storeId: string}>();
        const numericStoreId = storeId ? parseInt(storeId):0;
        const {data:store,isError,isLoading} = useSingleStoreAction(numericStoreId);

        const { control, register, handleSubmit, setValue, watch, formState: { errors } } = useForm<StorePublicInformation>();



        useEffect(()=>{
          if(store){
            setValue("phone",store.phone.slice(3));
            setValue("subTypeId",store.subType.id)
            setValue("type",store.subType.type.id)
            setValue("sectorId",store.sector?+store.sector.id:null);
            setValue("name",store.languages);
          }
        },[store,setValue])
        
        const {data:categories} = useCategories();
        const {data:subCategories} = useSubCategoriesByCategory(watch('type'));
        const {data:sectors} = useSectors();
        
        const selectedCategory = watch("type");
        const selectedSubTypeId = watch("subTypeId");
        const selectedSectorId = watch("sectorId");

        const {loading,updateResource} = useUpdateResource();

        const onSubmit = (data: StorePublicInformation) => {
          const url =numericStoreId?`store?storeId=${numericStoreId}`:"store";
          updateResource(url, {languages:data.name,subTypeId:data.subTypeId,phone:`966${data.phone}`,sectorId:data.sectorId,phoneLogin:data.phoneLogin} ,numericStoreId? "admin":"store",{
            method: "PUT",
            successMessage: t("update_success"),
            invalidateQueries:["store-detail-action"],
          });
        };

           
  return (
    <div>
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
      {
        store &&
        <form className="flex flex-col gap-6" onSubmit={handleSubmit(onSubmit)}>
        <UpdateStorePublicInformationForm
          register={register}
          errors={errors}
          control={control}
          selectedCategory={selectedCategory || null}
          onSelectCategory={(id) => {
            setValue("type", id, { shouldValidate: true });
            setValue("subTypeId", null, { shouldValidate: true });
          }}
          filteredSubTypes={subCategories||[]}
          selectedSubTypeId={selectedSubTypeId || null}
          onSelectSubType={(id) => setValue("subTypeId", id, { shouldValidate: true })}
          selectedSectorId={selectedSectorId}
          onSelectSector={(id)=>setValue("sectorId",id,{shouldValidate:true})}
          categories={categories||[]}
          sectors={sectors||[]}
        />
        {
          loading?
          <LoadingButton/>
          :
          <SubmitButton label='update'/>
        }
    </form>
      }
    </div>
  )
}

export default UpdateStorePublicInformation